import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const postStocks = async (stocks: any): Promise<any> => {
    const response = await authorizedAxiosInstance.post('/v2/stocks', { stocks });

    return response.data;
};
